import React, { createContext, ReactNode, useContext } from 'react';
import { useAssetsSliderNavigationState } from './hooks';

type AssetsSliderContextValue = ReturnType<
  typeof useAssetsSliderNavigationState
>;

const AssetsSliderContext = createContext<AssetsSliderContextValue | null>(
  null
);

const emptyNavigation: AssetsSliderContextValue = {
  aw: null,
  awId: undefined,
  isLocationSource: false,
  isApprovalList: false,
  sortedAssets: [],
  count: 0,
  currentAssetPosition: 0,
  selectedAssetId: undefined,
  activeAssetId: undefined,
  skeletonPosition: null,
  loadedStartIndex: 0,
  leadingSkeletonCount: 0,
  trailingSkeletonCount: 0,
  isSelectedAssetPending: false,
  loadMore: null,
  scrollLeftRef: { current: null },
  isMobileExpanded: false,
  setIsMobileExpanded: () => undefined,
  onChangeAsset: () => undefined,
  onPrev: () => undefined,
  onNext: () => undefined
};

/**
 * Keeps the assets slider state above the media viewer content, which is
 * remounted for every asset, so the slider list is not refetched on navigation.
 */
export function AssetsSliderProvider({ children }: { children: ReactNode }) {
  const value = useAssetsSliderNavigationState();
  return (
    <AssetsSliderContext.Provider value={value}>
      {children}
    </AssetsSliderContext.Provider>
  );
}

export function useAssetsSliderNavigation() {
  return useContext(AssetsSliderContext) ?? emptyNavigation;
}
